module.exports = __webpack_public_path__ + "img/1x.64adfb9.jpg";